module.exports = __webpack_public_path__ + "static/formalScript-fc4ec7e5cec36c8f5782cab205e9e64c.ttf";